const STATIC_PATH = '/static/img';

const TARGET_CPA = 'Target CPA';

export const BACKGROUND_IMAGE = `${STATIC_PATH}/budget-manager-campaigns-modal-background.png`;

export const BUDGET_MANAGER_CAMPAIGNS_MODAL_TEXTS = {
    TITLE: 'Budget Manager Automation',
    SUBTITLE: 'This is where you set up your Omnichannel Budget Manager. Select the campaigns you want to group together and let Tess take care of your monthly PPC budget.',
    SAVE_BUTTON: 'Save Clusters',
};

export const TABLE_DEFAULT_SORT = [{ id: 'status', desc: false }];

export const BUDGET_MANAGER_CAMPAIGNS_MODAL_TEST_IDS = {
    MODAL: 'budget-manager-campaigns-modal',
    LOADING_SKELETON: 'budget-manager-campaigns-modal-loading-skeleton',
};

export const UNKNOWN_BID_STRATEGY = '--';

export const TARGET_IMPRESSION_SHARE = 'Target Impression Share';

export const MANUAL_STRATEGY_TYPE = {
    cpm: 'Manual CPM',
    cpv: 'Manual CPV',
    cpc: 'Manual CPC',
};

export const TARGET_STRATEGY_TYPE = {
    [TARGET_CPA]: TARGET_CPA,
};

export const MAX_CHARACTERS_FOR_BID_STRATEGY_NAME = 45;
